export const VERSION = {version: '16.0.0-RC.202604252036', branch: 'master', date: 1777149368846};
